<span [wcCxJsonLd]="snippetImages()"></span>
<span [wcCxJsonLd]="snippetVideos()"></span>

<!-- Lame 1 Push Card Component -->
  @if (pushLame1) {
    <sd-component-wrapper [brand]="brandCorner" [themesConfig]="lameConfig?.lame1?.backgroundTheme">
      <sd-push-card sd-component-wrapper-component
                    [brand]="brandCorner"
                    [pushSize]="PushSizeEnum.l"
                    [push]="pushLame1"
                    [textConfig]="lameConfig?.lame1?.textConfig || PositionEnum.left"
                    [mediaConfig]="lameConfig?.lame1?.mediaConfig || PositionEnum.right"
                    [mediaAsBackground]="false"
                    [themesConfig]="lameConfig?.lame1?.theme || BrandThemesEnum.brand"
                    [titleLevel]="1"
                    [twicPicsAutoSize]="false"
                    [isDescription]="isDescriptionLame1"
                    [isFit]="isFitLame1"
                    [hasModal]="hasModalLame1"
                    (clicked)="onClickLink($event)"
      />
    </sd-component-wrapper>
  }

  @if (teasers?.length > 0) {
    <sd-teaser
      id="SdTeaserComponent_SubCategoryPage_1"
      [brand]="brandCorner"
      [data]="teasers"
      [titleLevel]="1"
      [twicPicsAutoSize]="false"
      (clicked)="onClickLink($event)"
    />
  }
  @if (isBannerVisible) {
    <sd-info-banner
      [brand]="brandCorner"
      [isVisible]="isBannerVisible"
      textKey="category.brandcorner.banner.text"
      [data]="bannerData"
      (isVisibleChange)="bannerVisibilityChange()"
    />
  }
  <!-- Lame 2 ProductCardGridModule slot -->
  <section>
    <wc-product-card-grid
      [brandCorner]="brandCorner"
      [productGridTitleLevel]="3"
      [currentCategory]="category?.name"
      [currentCategoryCode]="category?.code"
      [isCategoryPage]="true"
      [context]="productCardGridContext"
      [isLoading]="useLazyLoad && !gridLoaded"
      (hasLoaded)="onGridLoaded()"
    />
  </section>

  @if (lame1Loaded && gridLoaded) {
    <!-- Lame 3 PushCard slot -->
    <sd-theme-wrapper [brand]="brandCorner">
      <section>
        <cx-page-slot position="PushCard" />
      </section>
    </sd-theme-wrapper>
    <!-- Lame 4 Push Slider -->
    @if (contentLame4 && pushsLame4?.length > 0) {
      <section>
        <sd-component-wrapper
          [brand]="brandCorner"
          [content]="contentLame4"
          [textConfig]="lameConfig?.lame4?.titleTextConfig || PositionEnum.center"
          [themesConfig]="lameConfig?.lame4?.backgroundTheme"
        >
          @if (pushsLame4?.length > 0) {
            <sd-push-slider sd-component-wrapper-component
                            [brand]="brandCorner"
                            [pushs]="pushsLame4"
                            [titleLevel]="3"
                            [size]="lameConfig?.lame4?.pushSize || SizesEnum.s"
                            (clicked)="onClickLink($event)"
            />
          }
        </sd-component-wrapper>
      </section>
    }
    <!-- Lame 5 Comparator -->
    @if (contentLame5 && productCodesLame5?.length > 0) {
      <section>
        <sd-component-wrapper
          [brand]="brandCorner"
          [content]="contentLame5"
          [themesConfig]="lameConfig?.lame5?.backgroundTheme"
        >
          @if (productCodesLame5?.length > 0) {
            <wc-base-comparator sd-component-wrapper-component
                                [isUserFriendly]="true"
                                [productCodes]="productCodesLame5"
                                [context]="comparatorContext"
            />
          }
        </sd-component-wrapper>
      </section>
    }
    <!-- Lame 6 Reinsurance slot -->
    <sd-theme-wrapper [brand]="brandCorner">
      <section>
        <cx-page-slot position="Reinsurance" />
      </section>
    </sd-theme-wrapper>
    <!-- Lame 7 Push Card Component -->
    @if (pushLame7) {
      <section>
        <sd-component-wrapper [themesConfig]="lameConfig?.lame1?.backgroundTheme">
          @if (pushLame7) {
              <sd-push-card sd-component-wrapper-component
                            #pushCardComponent
                            [brand]="brandCorner"
                            [pushSize]="PushSizeEnum.l"
                            (click)="onPromoClick()"
                            [push]="pushLame7"
                            [textConfig]="lameConfig?.lame7?.textConfig || PositionEnum.center"
                            [mediaConfig]="lameConfig?.lame7?.mediaConfig || PositionEnum.right"
                            [mediaAsBackground]="false"
                            [themesConfig]="lameConfig?.lame5?.theme || ThemesEnum.promo2"
                            [titleLevel]="2"
                            [isDescription]="isDescriptionLame7"
                            [isFit]="isFitLame7"
                            [hasModal]="hasModalLame7"
                            (clicked)="onClickLink($event)"
              />
          }
        </sd-component-wrapper>
      </section>
    }
    @if (argumentsLame7) {
      <section>
        <sd-arguments
          id="SdArgumentsComponent_SubCategoryPage_1"
          [brand]="brandCorner"
          [data]="argumentsLame7"
          [themesConfig]="lameConfig?.lame7?.theme || ThemesEnum.default"
          [layoutTextConfig]="lameConfig?.lame7?.mediaConfig || PositionEnum.right"
          [textConfig]="lameConfig?.lame7?.textConfig || PositionEnum.left"
          [hasGradient]="lameConfig?.lame7?.hasGradient || false"
          [layout]="lameConfig?.lame7?.layout || ArgumentsLayoutEnum.default"
          (clicked)="onClickLink($event)"
        />
      </section>
    }
    <!-- Lame 8 Arguments -->
    @if (argumentsLame8) {
      <section>
        <sd-arguments
          id="SdArgumentsComponent_SubCategoryPage_2"
          [brand]="brandCorner"
          [data]="argumentsLame8"
          [themesConfig]="lameConfig?.lame8?.theme || ThemesEnum.default"
          [layoutTextConfig]="lameConfig?.lame8?.mediaConfig || PositionEnum.right"
          [textConfig]="lameConfig?.lame8?.textConfig || PositionEnum.left"
          [hasGradient]="lameConfig?.lame8?.hasGradient || false"
          [layout]="lameConfig?.lame8?.layout || ArgumentsLayoutEnum.default"
          (clicked)="onClickLink($event)"
        />
      </section>
    }
    <!-- Lame 9 Recipe List Component -->
    @if (isRecipesEnabled && contentLame9 && recipes) {
      <section>
        <sd-component-wrapper
          [brand]="brandCorner"
          [content]="contentLame9"
          [themesConfig]="lameConfig?.lame9?.backgroundTheme"
        >
          @if (recipes) {
            <wc-base-list-recipe sd-component-wrapper-component
                                 [recipeCards]="recipes"
                                 [totalCount]="recipesSize"
            />
          }
        </sd-component-wrapper>
      </section>
    }
    <!-- Lame 10 Arguments -->
    @if (argumentsLame10) {
      <section>
        <sd-arguments
          id="SdArgumentsComponent_SubCategoryPage_3"
          [brand]="brandCorner"
          [data]="argumentsLame10"
          [themesConfig]="lameConfig?.lame10?.theme || ThemesEnum.default"
          [layoutTextConfig]="lameConfig?.lame10?.mediaConfig || PositionEnum.right"
          [textConfig]="lameConfig?.lame10?.textConfig || PositionEnum.center"
          [hasGradient]="lameConfig?.lame10?.hasGradient || false"
          [layout]="lameConfig?.lame10?.layout || ArgumentsLayoutEnum.default"
          (clicked)="onClickLink($event)"
        />
      </section>
    }
    <!-- Lame 11 FAQ -->
    @if (faqs?.length > 0) {
      <section>
        <sd-component-wrapper
          [brand]="brandCorner"
          [content]="faqWrapper"
          [themesConfig]="lameConfig?.lame1?.backgroundTheme"
        >
          @if (faqs?.length > 0) {
            <wc-base-faq sd-component-wrapper-component [faqEntries]="faqs" />
          }
        </sd-component-wrapper>
      </section>
    }
    <!-- Lame 12 SEO -->
    @if (!hideSeo && seo?.paragraphs?.length > 0) {
      <section>
        <sd-seo-wrapper [brand]="brandCorner" [data]="seo" />
      </section>
    }
    <wc-sticky-product-comparator />
  }
